import { ViewModel } from '@platform/api'
let { getGlobalStorage } = ViewModel;

export default function getUserId() {
    let userid = '';
    let userDataJSON = getGlobalStorage('localStorage', "STOREFORINFODATA");
    let userData = userDataJSON && JSON.parse(userDataJSON);
    userid = userData && userData.userId;
    return userid;
}   